import { Box, Stack, Typography } from "@mui/material";
import type { JSX } from "react";
import { Fragment } from "react";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis.tsx";
import type { TemplateFieldsItem } from "../../../../../api/types/svTypes.ts";
import MetaIcon from "../../sv/components/common/MetaIcon.tsx";
import NavigationParentIcon from "@entrilia/shared/icons/NavigationParentIcon.tsx";

interface Props {
  fields: { [key: string]: TemplateFieldsItem[] };
}
export default function TemplateInfoFields({ fields }: Props) {
  return (
    <Stack sx={{ gap: 2 }}>
      <Typography variant="subtitle1">Fields</Typography>
      <Stack sx={{ gap: 2 }}>
        {Object.entries(fields).map(([key, items]) => (
          <Container key={key} title={key} items={Object.values(items).flat()} />
        ))}
      </Stack>
    </Stack>
  );
}
interface ContainerProps {
  title: string;
  items: TemplateFieldsItem[];
}
function Container({ title, items }: ContainerProps) {
  if (items.length === 0) return null;
  return (
    <Stack sx={{ gap: 0.5 }}>
      <Typography variant="subtitle1" sx={{ textTransform: "capitalize" }}>
        {title}
      </Typography>
      {items.map((item, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <RowContainer key={index} icon={<MetaIcon icon={item.icon} />} name={item.name} subItems={item.subItems} />
      ))}
    </Stack>
  );
}

type FieldItemProps = {
  name: string;
  icon: JSX.Element;
  subItems?: TemplateFieldsItem[];
};
function RowContainer({ name, icon, subItems }: FieldItemProps) {
  return (
    <Stack
      sx={(theme) => ({
        width: 245,
        px: 0.75,
        border: `1px solid ${theme.palette.action.disabledBackground}`,
        borderRadius: 1,
      })}
    >
      {RowItem({ name, icon, subItems })}
      {subItems &&
        subItems.map((i, index) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <Fragment key={index}>{RowItem({ name: i.name, icon: <NavigationParentIcon /> })}</Fragment>
        ))}
    </Stack>
  );
}

function RowItem({ name, icon, subItems }: FieldItemProps) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        gap: 1,
        py: 0.5,
        borderBottom:
          subItems && subItems.length > 0 ? `1px dashed ${theme.palette.action.disabledBackground}` : "none",
      })}
    >
      <Box
        sx={(theme) => ({
          width: 20,
          height: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          svg: {
            color: theme.palette.action.active,
          },
        })}
      >
        {icon}
      </Box>
      <TypographyTooltipEllipsis text={name} />
    </Box>
  );
}
